module.exports = __webpack_public_path__ + "media/images/topographic-map-252c9a5435c4b3e414dc4a0c841e6014.svg";